import { CoachingCultureTheme, getDefaultTheme } from "@coaching-culture/ui";

const getTheme = (): CoachingCultureTheme => getDefaultTheme();

export default getTheme;
